// extracted by mini-css-extract-plugin
export default {"styledModal":"NewsModal_styledModal__7FTVx","showLogo":"NewsModal_showLogo__XmqXD"};